<template>
  <div :class="{price: !inline, inline: inline}" v-if="!hidePrice">
    <template v-if="inline"> – </template>
<!--    <template v-if="membershipType.inviteOnly">{{ $t('membership.inviteOnly')}}<template v-if="hasPrice">, </template></template>-->
    <template v-if="hasPrice">
      <template v-if="showTrial && membershipType.hasTrialPeriod && membershipType.trialDays > 0">
        {{ $tc('membership.days_free', membershipType.trialDays, {count: membershipType.trialDays}) }}
        <template v-if="showSubscriptionPrice"> {{ $t('membership.then') }}</template>
      </template>
      <template v-else-if="showTrial && membershipType.hasTrialPeriod && membershipType.trialUntilDate != null">
        {{ $t('membership.free_until') }} <span v-text="formatDate(membershipType.trialUntilDate)"/>
        <template v-if="showSubscriptionPrice"> {{ $t('membership.then') }}</template>
      </template>
      <template v-if="membershipType.type=='subscription'">
        <template v-if="showSubscriptionPrice">
          <template v-if="membershipType.subscriptionInterval == 'monthly'">
            {{ $n(membershipType.price, `${branch}_currency`) }}{{$tc('membership.per_n_months', membershipType.validFor,
            {count: membershipType.validFor})}}
          </template>
          <template v-else-if="membershipType.subscriptionInterval == 'yearly'">
            {{ $n(membershipType.price, `${branch}_currency`) }}{{$tc('membership.per_n_years', 1, {count: 1})}}
          </template>
        </template>
      </template>
      <template v-else-if="membershipType.type=='product'">
        <template v-if="membershipType.subscriptionInterval == 'monthly'">
          {{ $n(membershipType.price, `${branch}_currency`) }} {{$tc('membership.for_n_months', membershipType.validFor,
            {count: membershipType.validFor})}}
        </template>
        <template v-else-if="membershipType.subscriptionInterval == 'yearly'">
          {{ $n(membershipType.price, `${branch}_currency`) }} {{$tc('membership.for_n_years', 1, {count: 1})}}
        </template>
      </template>


    </template>
    <div v-if="description" class="description" v-text="description"/>
  </div>
</template>
<script>
export default {
  name: 'MembershipPrice',
  props: {
    membershipType: {},
    inline: {
      type: Boolean,
      default: false,
    },
    showTrial: {
      type: Boolean,
      default: true,
    },
    description: {
      type: String,
      default: null,
    }
  },
  computed: {
    branch() {
      return process.env.FG_APP_BRANCH
    },
    hasTrialPeriod() {
      return this.membershipType.hasTrialPeriod;
    },
    showSubscriptionPrice() {
      if (this.hasTrialPeriod &&
        (this.membershipType.stopRenewal || !this.membershipType.trialPaymentSourceRequired)) {
        return false;
      }
      return true;
    },
    hasPrice() {
      return this.membershipType.price!==null;
    },
    hidePrice() {
      return Boolean(this.membershipType.hidePrice);
    }
  }
}
</script>
<style lang="scss" scoped>
.price {
  margin-bottom: 1rem;
  color: $nav-active;
  letter-spacing: .75px;
  font-size: 30px;
  font-family: apotek-comp, sans-serif;
  line-height: .9;
}
.description {
  display: inline;
  margin-left: 20px;
  @media screen and (max-width: 750px) {
    display: block;
    margin-left: 0;
    margin-top: 1rem;
  }
  font-family: $base-font-family;
  font-size: 0.875rem;
  color: $body-color;
  letter-spacing: 0;
  font-style: italic;
}
.inline {
  display: inline;
}
</style>